import React from 'react';
import { Button, ListGroup, ListGroupItem } from 'reactstrap';

const ComponentManager = ({components, onSelectComponent,activeComponent,onEdit, onDelete})=>{
    return(
        <React.Fragment>
            <ListGroup>
                {components.map(component => (
                    <ListGroupItem 
                        key={component.id} 
                        onClick={() => onSelectComponent(component)}
                        tag="button"
                        action
                        active={activeComponent && activeComponent.id === component.id}
                        className="float-action-list-item"
                    >
                        <div className="float-action-content">
                            <span>{component.component_name}</span>
                            <div className="float-action-buttons">
                                <Button 
                                    size="sm" 
                                    color="warning" 
                                    outline
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        onEdit({
                                            ...component,
                                            name:component?.component_name,
                                            listgroup:'Component'});
                                    }}
                                >
                                    <span className='ri-pencil-fill'></span>
                                </Button>
                                <Button 
                                    size="sm" 
                                    color="danger" 
                                    outline
                                    onClick={(e) => { 
                                        e.stopPropagation(); 
                                        onDelete({
                                            ...component,
                                            name:component?.component_name,
                                            listgroup:'Component'});
                                    }}
                                >
                                    <span className='ri-delete-bin-line'></span>
                                </Button>
                            </div>
                        </div>
                    </ListGroupItem>
                ))}
            </ListGroup>
        </React.Fragment>
    )
}

export default ComponentManager;